import { Products } from 'enums';
import useUserStore from 'stores/user-store';
import type { License } from 'types/licenses.types';

/**
 * Returns true when the logged-in tenant owns an active, non-expired licence
 * for the given product.  No alias mapping needed – product names now match
 * the backend 1:1.
 */
export const useHasLicense = (product: Products): boolean => {
  const licenses: License[] = useUserStore((state) => state.licenses);

  return licenses.some(
    (lic) => lic.product === product && lic.isActive && !lic.isExpired
  );
};
